module.exports = __webpack_public_path__ + "img/dmg.b1305a1e.svg";